$(document).ready(function () {

    const get_current_size = () => {
        const window_width = $(window).width();
        if( window_width < 565 ){ return 'xs' }
        if( 576 <= window_width && window_width < 768){ return 'sm' }
        if( 768 <= window_width && window_width < 992){ return 'md' }
        if( 992 <= window_width && window_width < 1290 ){ return 'lg' }
        if( 1290 <= window_width  ){ return 'xl' }
    }

    $(document.body).on("click", ".js-call-modal", function(e) {
        e.preventDefault()
        let needModalId = $(this).attr("data-modal-id")

        $("body").addClass("overflow-hidden")
        $(".modal").addClass("modal-is-visible")

        $('[data-id="'+needModalId+'"]').addClass("modal-is-visible")

        $(".modal__body").css("maxHeight", $(window).innerHeight() - 60+"px")

    })



    let mousemoveCounter = 0
    const leaveFromTop = (e) => {
        if (e.clientY < 0 && mousemoveCounter == 0 && get_current_size() == 'xl') {
            mousemoveCounter = 1
            let needModalId = $("body").attr("data-modal-id")
            $("body").addClass("overflow-hidden")
            $(".modal").addClass("modal-is-visible")
            $('[data-id="'+needModalId+'"]').addClass("modal-is-visible")
            $(".modal__body").css("maxHeight", $(window).innerHeight() - 40+"px")




        }
    }
    $(document).on('mouseleave', leaveFromTop)


    $(".modal__overlay, .modal__close").click(function (e) {
        $(".modal-is-visible").removeClass("modal-is-visible")
        $("body").removeClass("overflow-hidden")
    })



    $(".js-video-play").click(function (e) {
        $('#introVideo').get(0).play()
    })

    $(document.body).on("click", ".js-goToSection", function(e) {
        e.preventDefault()
        let pointSection = $(this).attr("href")
        $('html,body').stop().animate({ scrollTop: $(pointSection).offset().top }, 700)
    });


})